import { render } from "./PieChart.vue?vue&type=template&id=613cd82a"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
script.render = render

export default script